import {useCallback, useEffect, useState} from 'react';

export const useTaskHighlighting = (highlightedTaskId, clearHighlightedTask) => {
  const [highlightedTask, setHighlightedTask] = useState(null);

  const clearHighlight = useCallback(() => {
    setHighlightedTask(null);
    clearHighlightedTask?.();
  }, [clearHighlightedTask]);

  // Listen for custom event 'highlightTask' (dispatched from elsewhere in app)
  useEffect(() => {
    const handleHighlight = (event) => {
      const { taskId, jobId } = event.detail;
      setHighlightedTask({ id: taskId, jobId });
      setTimeout(() => {
        clearHighlight();
      }, 2000);
    };
    window.addEventListener('highlightTask', handleHighlight);
    return () => window.removeEventListener('highlightTask', handleHighlight);
  }, [clearHighlight]);

  // React to prop change (external highlight trigger)
  useEffect(() => {
    if (highlightedTaskId) {
      setHighlightedTask({ id: highlightedTaskId });
      setTimeout(() => {
        clearHighlight();
      }, 2000);
    }
  }, [highlightedTaskId, clearHighlight]);

  return { highlightedTask, setHighlightedTask, clearHighlight };
};